import type { PropsWithChildren } from "react";
import styles from "./HeaderBanner.module.css";

type HeaderBannerProps = {
  backdrop: JSX.Element;
};

export default function HeaderBanner({
  backdrop,
  children,
}: PropsWithChildren<HeaderBannerProps>) {
  return (
    <div className={styles.HeaderBannerContainer} id="HeaderBannerContainer">
      <div className={styles.HeaderBannerBackdrop}>{backdrop}</div>
      <div className={styles.HeaderBannerContentContainer}>
        <div className="AppLayout">
          <section>
            <header className={styles.HeaderBannerContent}>{children}</header>
          </section>
        </div>
      </div>
    </div>
  );
}
